export default "__VITE_ASSET__bwpshXK1__"